import type { Denial } from './api'
import { translate, type Lang } from './i18n'
import { dataState, showsRows, type DataState } from './state'

/**
 * El aviso que corresponde al estado de un listado (§13, *Definition of Done*).
 *
 * Existe para que las catorce listas del Centro de Mando no vuelvan a decidir qué mostrar con un
 * `length === 0` suelto. Esa cuenta no distingue «no hay ninguno» de «todavía no llegó» ni de «no
 * se pudo cargar», y las tres se veían igual: como una afirmación de que no hay nada.
 *
 * El texto de vacío lo pone cada pantalla —«no hay unidades conformadas» no se parece a «ningún
 * conjunto publicado»— y los otros tres son comunes, porque no dependen de qué se estaba pidiendo.
 */
export function DataNote({
  lang, loaded, problem, count, empty,
}: {
  lang: Lang
  /** Si alguna carga de esta área terminó bien alguna vez. */
  loaded: boolean
  /** El último fallo, o `null` si la última carga salió bien. */
  problem: Denial | null
  count: number
  /** Clave del diccionario con el «no hay ninguno» propio de esta pantalla. */
  empty: string
}) {
  const state = dataState(loaded, problem, count)
  if (state === 'ready') return null

  // Degradado se avisa en amarillo y **sin ocultar las filas**: lo que se ve sigue sirviendo, solo
  // que es de antes. Los otros tres no tienen filas detrás.
  return (
    <p className={state === 'stale' ? 'notice warning' : 'notice'} data-state={state}>
      {translate(lang, state === 'empty' ? empty : `state.${state}`)}
    </p>
  )
}

export { dataState, showsRows, type DataState }
